import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavbarContainer = styled.nav`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
`;

export const NavLinks = styled.div`
    display: flex;
    gap: 20px;
`;

export const NavLink = styled(Link)`
    text-decoration: none;
    color: #007bff;
`;

export const Button = styled.button`
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
`;

export const LogoutButton = styled(Button)`
    background-color: #dc3545;
    
    &:hover {
        background-color: #c82333;
    }
    margin-left: 10px;
`;